export default {
  label: {
    forgot_password: "Forgot password?",
    change_agency_login: "Agency Sign In"
  },
  error: {
    login: "メールアドレス、またはパスワードが間違っています"
  }
};
